import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Car, FileText, Phone, MessageCircle, BookOpen } from 'lucide-react';
import CatalogueModal from './CatalogueModal';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const QuickNextSteps = () => {
    const [isCatalogueOpen, setIsCatalogueOpen] = useState(false);
    const { language } = useLanguage();
    const t = translations[language].nextSteps;

    const steps = [
        {
            label: t.requestBrochure,
            icon: BookOpen,
            action: () => setIsCatalogueOpen(true),
            external: false
        },
        {
            label: t.findShowroom,
            icon: MapPin,
            link: '/connect/contact-us',
            external: false
        },
        {
            label: t.bookTestDrive,
            icon: Car,
            link: '/test-drive',
            external: false
        },
        {
            label: t.requestQuote,
            icon: FileText,
            link: '/connect/contact-us', // Assuming quote request is part of contact form
            external: false
        },
        {
            label: t.callTollFree,
            icon: Phone,
            link: 'tel:80050800',
            external: true
        },
        {
            label: t.whatsapp,
            icon: MessageCircle,
            link: 'https://wa.me/96879005800',
            external: true
        }
    ];

    return (
        <section className="py-8 bg-white">
            <CatalogueModal isOpen={isCatalogueOpen} onClose={() => setIsCatalogueOpen(false)} />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-3xl md:text-4xl font-light text-center mb-12 relative pb-4 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-px after:bg-black uppercase tracking-wide">
                    {t.title}
                </h2>

                <div className="grid grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-4 items-start justify-center">
                    {steps.map((step, index) => {
                        const Icon = step.icon;
                        const isExternal = step.external;
                        const Wrapper = step.action ? 'button' : (isExternal ? 'a' : Link);
                        const props = step.action
                            ? { onClick: step.action }
                            : (isExternal
                                ? { href: step.link, target: step.link.startsWith('http') ? "_blank" : undefined, rel: "noreferrer" }
                                : { to: step.link }
                            );

                        return (
                            <Wrapper key={index} {...props} className="group flex flex-col items-center text-center gap-4 p-4 hover:bg-gray-50 rounded-lg transition-colors">
                                <div className="w-16 h-16 rounded-full border border-gray-800 flex items-center justify-center text-gray-800 group-hover:bg-red-600 group-hover:border-red-600 group-hover:text-white transition-all duration-300">
                                    <Icon strokeWidth={1} size={32} />
                                </div>
                                <span className="text-sm font-medium text-gray-600 uppercase tracking-widest leading-relaxed max-w-[120px]">
                                    {step.label}
                                </span>
                            </Wrapper>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default QuickNextSteps;
